import { useEffect, useState } from 'react';
import {
  scheduleTime,
  scheduleTimeForFirstStep,
  immediateDelay,
} from '@/constants/step-management-delay';
import { useKFlags } from '@/hooks/use-k-flags';

interface DelayOption {
  label: string;
  value: number;
}

interface OutreachStep {
  id?: string | number;
  step?: number;
  channel?: string;
}

interface UseDelayParams {
  outreach?: { steps?: OutreachStep[] };
  step?: OutreachStep;
}

export const getDelayById = (
  stepInterval?: number
): DelayOption | undefined => {
  const delay: DelayOption[] = [
    ...scheduleTime,
    ...scheduleTimeForFirstStep,
    ...immediateDelay,
  ];
  return delay.find((time) => time.value === stepInterval);
};

export const useDelay = ({
  outreach = {},
  step = {},
}: UseDelayParams): DelayOption[] => {
  const { firstStepDelay } = useKFlags();
  const [delayOption, setDelayOption] = useState<DelayOption[]>([]);
  const firstDelay: DelayOption = {
    label: `${firstStepDelay} Mins`,
    // Cast: useKFlags is a legacy untyped module, so flag values are untyped.
    value: firstStepDelay as number,
  };

  useEffect(() => {
    if (!outreach?.steps?.length || step?.step === 1) {
      // Add the delay from flag in options, Only if its not 10 or 60 as its been already added for all customers by default, Still keeping this flag for testing use case
      const delaysforFirstStep =
        firstStepDelay !== 60 && firstStepDelay !== 10
          ? [firstDelay, ...scheduleTimeForFirstStep]
          : [...scheduleTimeForFirstStep];
      // eslint-disable-next-line react-hooks/set-state-in-effect -- pre-existing effect that seeds delay options on mount; not refactoring during an import move
      setDelayOption(delaysforFirstStep);
      return;
    }
    const lastStep = outreach?.steps[outreach?.steps?.length - 1];
    if (!step?.id && lastStep?.channel !== step?.channel) {
      setDelayOption([...immediateDelay, ...scheduleTime]);
      return;
    }
    const currStepIndex = outreach?.steps.findIndex(
      (currStep) => currStep?.id === step?.id
    );
    const prevStep = outreach?.steps[currStepIndex - 1];
    if (step?.id && prevStep?.channel !== step?.channel) {
      setDelayOption([...immediateDelay, ...scheduleTime]);
      return;
    }
    setDelayOption(scheduleTime);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- options are intentionally seeded once from the mount-time outreach/step shape

  return delayOption;
};
